import { useMutation } from "react-query";
import { updateAcquisition } from "../../../../../actions/Utilities/Acquisition";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  editStateAcquisitionConfig,
  acquisitionConfigReFetching,
} from "../atoms/atoms";
import { IAcquisitionConfig } from "../Type";
import { toast } from "components/toastNotification";

const useEditAcquisition = () => {
  const setActionEditState = useSetRecoilState(editStateAcquisitionConfig);
  const [isReFetching, setIsReFetching] = useRecoilState(
    acquisitionConfigReFetching
  );

  const { mutate } = useMutation(
    (newData: IAcquisitionConfig) => updateAcquisition(newData),
    {
      onSuccess: (res) => {
        if (typeof res == "object") {
          toast.fire(
            "Updating Acquisition Config failed",
            `${res.Message}`,
            "error"
          );
        } else {
          let title = "Updating Acquisition Config Failed";
          let message = "";
          let type: "success" | "error" | "warning" = "error";

          if (res == "Success") {
            title = "Success";
            message = "Acquisition Config Updated Successfully";
            type = "success";
          } else if (res == "Action object is null") {
            title = "Action object is Null";
            message = "Action Object is missing.";
            type = "error";
          } else if (res == "The data already exists!") {
            title = "Updating Acquisition Config failed ";
            message = `Duplication Error: ${res}`;
            type = "error";
          } else if (res.includes("Notification insert Failed")) {
            title = "Success";
            message = `Acquisition Config Updated Successfully, BUT ${res}`;
            type = "warning";
          } else if (
            ["Operation Failed!", "Acquisition Name not found"].includes(res)
          ) {
            message = `Error: ${res}`;
          }

          toast.fire(title, message, type);
        }
        setActionEditState(false);
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire(
          "Update Acquisition Config failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );
  return mutate;
};

export default useEditAcquisition;
